import { css, html, LitElement, TemplateResult } from "lit";
import {property, customElement} from 'lit/decorators.js';
import { FiSubView, UiStateModel, UiStateModelParam } from "../../../src/models/ui-state-model";
import { PortViewModel } from "../../../src/models/port-view-model";
import { SvgIcons } from "../../voyage-svg-icons/src/voyage-svg-icons";
import { FormatDateToLocalTime, prettyTimelapsed } from "../../../src/utils/helpers";
import { VoyageCheckbox } from "../../voyage-checkbox/src/voyage-checkbox";
import { getFormattedDataSource } from "../../../src/utils/utils";
import { VoyMapModel } from "../../../src/models/voy-map-model";
import { regionsMap } from "../../../src/models/terminals-model-impl";
import { VoyageShoreContextModel } from "../../../src/models/voyage-shore-context-model";
import { TerminalsModel } from "../../../src/models/terminals-model";
import { PortInfo } from "../../../src/models/types/terminals-model.types";
import { FilterUtils } from "../../voy-global-filters/src/filter-utils";
import { VoyageFilterResult } from "../../voy-global-filters/src/types";
import { ListEntry } from "../../../src/models/types/port-view-model.types";
import { differenceInHours } from "date-fns";
import { ShoreContextEvent } from "../../../src/models/types/voyage-shore-context-model.types";
import "../../voyage-checkbox/src/voyage-checkbox";
import '../../voyage-spinner/src/voyage-spinner';
import '../../voyage-tooltip/src/voyage-tooltip-proxy'

@customElement('voy-fleet-sub-view-port-view')
export class VoyFleetSubViewPortView extends LitElement {
    @property({ type: String }) public ocl?: string;
    @property({ type: String }) public portCityId?: string;
    @property({ type: Boolean, attribute: false }) _showContainerWithPortMemo: boolean = false;

    @property({ attribute: false }) private _selectedPort?: PortInfo;
    @property({ attribute: false }) private _selectedTerminals: VoyageFilterResult | null = null;
    @property({ attribute: false }) private _showFilterPopup: boolean = false;
    @property({ attribute: false }) private _isDataFetching: boolean = false;
    @property({ type:Boolean }) private  _timeLineVisible : any =  false;

    constructor() {
        super();

        this._modelUpdated = this._modelUpdated.bind(this);
        this._getPortInfo = this._getPortInfo.bind(this);
        this._launchPortMemo = this._launchPortMemo.bind(this);
        this._portViewModelUpdated = this._portViewModelUpdated.bind(this);
        this._setCurrentTerminal = this._setCurrentTerminal.bind(this);
        this._showTerminalsForCurrentPort = this._showTerminalsForCurrentPort.bind(this);
        this._filterOnSelctedTermial = this._filterOnSelctedTermial.bind(this);
        this._renderHeader = this._renderHeader.bind(this);
        this._formatDatetoLT = this._formatDatetoLT.bind(this);
        this._toggleTimeLine = this._toggleTimeLine.bind(this);
        if(localStorage.getItem("timeLineView")!==undefined) {
            this._timeLineVisible = localStorage.getItem("timeLineView")=="true";
        }
    }

    static get styles() {
        return [
            css`
            :host {
                font-family: MaerskText;
                font-size: 14px;
                line-height: 20px;
                font-weight: 400;
            }
            section {
                display: flex;
                flex-direction: column;
                padding: 0px;
            }
            section {
                border-bottom: 1px solid var(--neutrals-grey-06);
                box-shadow: var(--voyage-box-shadow) 0px 6px 10px;
            }
            .scrollhost + section {
                padding-top: 24px;
            }
            h1 {
                font-family: MaerskHeadline;
                font-size: 26px;
                line-height: 32px;
                margin: 0;
                font-weight: 400;
                color: var(--neutrals-grey-02);
            }
            header {
                display: flex;
                flex-direction: row;
                column-gap: 4px;
                justify-content: flex-start;
                border-bottom: 1px solid var(--neutrals-grey-06);
                padding: 0 16px 24px 16px;
            }
            header button {
                background: none;
                border: none;
                cursor: pointer;
                padding: 0;
                padding-top: 6px;
                margin-left: -6px;
                display: flex;
            }
            voy-dot-menu {
                left: 8px;
                bottom: 4px;
            }
            span svg {
                width: 15px;
                height: 15px;
                margin-left: 8px;
                margin-bottom: -3px;
            }
            .item {
                padding: 16px;
                border-top: 2px solid var(--neutrals-grey-07, grey);
                border-bottom: 2px solid var(--neutrals-grey-07, grey);
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-gap: 16px 16px;
            }
            .item[selected] {
                background: var(--neutrals-grey-08, grey);
            }
            .item~.item {
                border-top: none;
            }
            .item h2 {
                font-size: 14px;
                line-height: 20px;
                margin: 0;
                color: var(--voyage-blue-dark);
                cursor: pointer;
            }
            .item h3 {
                color: var(--functional-grey-700, grey);
                font-size: 12px;
                font-weight: lighter;
                line-height: 20px;
                margin: 0;
            }
            .vessel-type {
                font-size: 12px;
            }
            .item p {
                font-size: 12px;
                line-height: 20px;
                font-weight: 400;
                margin: 0;
            }
            .item p.provenance {
                font-size: 12px;
                line-height: 20px;
            }
            .item p.menu {
                font-size: 12px;
                line-height: 20px;
                color: var(--voyage-blue-dark)
            }
            [data-title]:hover:before, [data-title]:hover:after {
                opacity: 1;
                transition: all 0.1s ease 0.5s;
                visibility: visible;
            }
            [data-title]:before {
                content: attr(data-title);
                position: absolute;
                bottom: 2em;
                left: -1.5em;
                padding: 4px 4px 4px 8px;
                background: var(--neutrals-grey-10, white);
                width: 10em;
                border-radius: 5px;
                box-shadow: 0px 0px 4px var(--voyage-box-shadow, #666);
                opacity: 0;
                z-index: 99999;
                visibility: hidden;
                clip-path: polygon(-5% -5%, 105% -5%, 105% 105%, calc(50%+1em) 105%, calc(50%+1em) 95%, calc(50%-1em) 95%, calc(50%-em) 105%, -5% 105%);
            }
            [data-title]:after {
                content: '';
                opacity: 0;
                position: absolute;
                width: 0;
                height: 0;
                bottom: 0em;
                left: 0%;
                border-bottom: none;
                border: 1em solid transparent;
                border-top-color: var(--neutrals-grey-10, white);
                filter: drop-shadow(0px 0px 2px var(--voyage-box-shadow,#666));
                z-index: 99999;
                visibility: hidden;
                clip-path: polygon(0% 0%, 100% 0%, 100% 60%, 0% 60%);
            }
            [data-title] {
                position: relative;
            }

            .hostdiv {
                padding-top: 24px;
                padding-bottom: 0px;
                max-height: calc(100vh - 186px);
                display: flex;
                flex-direction: column;
            }

            .hostdiv-full{
                max-height: calc(100vh - 129px);
            }

            .scrollhost {
                overflow-x: visible;
                overflow-y: auto;
            }

            [dubvious] {
                color: var(--voyage-error-red, red);
                text-decoration: line-through;
            }
            nav {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-items: center;
                padding: 16px;
                row-gap: 4px;
                column-gap: 12px;
            }
            nav button, nav div {
                font-family: MaerskText;
                display: flex;
                column-gap: 7px;
                align-items: center;
                background: none;
                color: var(--voyage-blue-dark);
                border: none;
                flex: 1 0 calc(50% - 16px);
                text-align: left;
                cursor: pointer;
                padding: 0;
                height: 26px;
                line-height: 26px;
            }
            nav button  span[is-handled="true"] {
                background-color: var(--neutrals-grey-04);
            }
            nav button svg {
                width: 20px;
                fill: currentColor;
            }
            .port-memo-btn{
                white-space: none;
            }
            .memo-title{
                white-space: nowrap;
            }

            .port-memo-title{
                color: var(--neutrals-grey-03, gray);
                margin: 0px 8px 8px 4px;
                font-family: MaerskText;
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                letter-spacing: 0em;
                text-align: left;
                white-space: nowrap;
            }
            .show-terminals-container {
                width: 100%;
                display: flex;
                justify-content: space-between;
            }
            .loading-header-container{
                width: 100%;
                display: flex;
                justify-content: flex-start; 
            }
            .ports-title {
                width: 100%;
            }

            .terminals-popup-title{
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .terminals-popup-title span {
                font-family: MaerskText;
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                letter-spacing: 0em;
                text-align: left;
                
                color: var(--waypoint-editor-coordinates-text);
            }
            .terminals-popup-title button {
                background: none;
                border: none;
                outline: none;
                cursor: pointer;
                fill: var(--primary-blue-900, blue);
                padding: 5px 0 0 19px;

            }
            .terminals-popup-title button > svg {
                display: block;
                width: 8px;
            }
            .checkboxes-wrapper {
                padding-top: 10px;
            }
            .spinner-container {
                position: relative;
                width: 35px;
                padding: 0 0 0 24px;
                align-self: center;
            }
            .spinner-container .loading-spinner voyage-spinner{
                width: 25px;
                height: 25px;
            }
            .position-info {
                display: flex;
                justify-content: flex-end;
            }

            .position-info span {
                display: flex;
                justify-content: center;
                color: var(--functional-grey-800, darkgrey);
                text-align: center;
                font-size: 10px;
                border-radius: 20px;
            }
            .data-source {
                margin-left: 2px;
                display: none;
            }
            .vessel-name-container {
                display: flex;
            }
            .maersk-icon {
                align-self: start;
                margin-left: 0px;
            }
            .gray-bg {
                background-color: #CFCFCF;
                width: 7em;
                height: fit-content;
            }

            .red-bg{
                background-color: #E9B2B7;
                width: 5em;
            }

            .green-bg {
                background-color: #C5E5C2;
                width: 5em;
            }
        `
        ]
    }

    firstUpdated() {
        this._getPortInfo();
        const filterString = UiStateModel!.getValue('q');
        const filters = filterString && FilterUtils.stringToFilter(filterString);
        this._selectedTerminals = filters && filters.commands.find(el => el.cmd === 'tml') || null;
        this._isDataFetching = true;
    }

    connectedCallback() {
        super.connectedCallback();
        PortViewModel?.addEventListener('port-view-model-updated', this._portViewModelUpdated);
        UiStateModel!.addEventListener(`${UiStateModelParam.PORT}-change`, this._setCurrentTerminal);
        PortViewModel?.setOclAndPort(this.ocl, this.portCityId);
        VoyageShoreContextModel!.addEventListener(ShoreContextEvent.TimeLineViewToggle, this._toggleTimeLine);

    }

    disconnectedCallback() {
        super.disconnectedCallback();
        PortViewModel?.removeEventListener('port-view-model-updated', this._portViewModelUpdated);
        UiStateModel!.removeEventListener(`${UiStateModelParam.PORT}-change`, this._setCurrentTerminal);
        PortViewModel?.stopFetchingData();
        VoyageShoreContextModel!.removeEventListener(ShoreContextEvent.TimeLineViewToggle, this._toggleTimeLine);
    }

    private _setCurrentTerminal(evt: Event) {
        this.portCityId = (<CustomEvent>evt).detail.value as string;
    }

    private _portViewModelUpdated() {
        this._isDataFetching = false;
        this._getPortInfo();
        this._modelUpdated();
    }

    private _getPortInfo(): void {
        if (!this.portCityId) return;
        this._selectedPort = VoyageShoreContextModel!.ports.get(this.portCityId);
    }

    private _launchPortMemo(terminalCode: string): (e: Event) => void {
        return (e: Event) => {
            this.dispatchEvent(new CustomEvent('show-port-memo', {
                detail: {
                    terminalCode,
                },
                bubbles: true,
                composed: true,
            }));
        }
    }

    private _goBack() {
        this._selectedTerminals = null;
        UiStateModel!.setValue(UiStateModelParam.FISubView, FiSubView.VesselDetails);
        this._resetPortFilter();
        VoyMapModel!.setZoomLevel(3);
    }

    private _resetPortFilter() {
        UiStateModel!.setValue(UiStateModelParam.PORT);
        UiStateModel!.setValue(UiStateModelParam.PortRegion);
        UiStateModel!.setValue(UiStateModelParam.ListView, 'ports');
        const filterString = UiStateModel!.getValue('q');
        const filters = filterString && FilterUtils.stringToFilter(filterString);
        if (filters) {
            const newFilters = filters.commands.filter(el => el.cmd !== 'tml');
            const newFiltersToString = FilterUtils.filterToString({ commands: newFilters });
            UiStateModel!.setValue('q', newFiltersToString);
        }
    }

    render() {
        let className = this._timeLineVisible ? "hostdiv" : "hostdiv hostdiv-full"
        return html`
            <div class=${className}>
                <section>
                    <header>
                        <button @click=${this._goBack} data-test="back-button">${SvgIcons.customChevronLeft}</button>
                        <div class="ports-title">
                            ${this.ocl ? html`${this._renderHeader('ocl', PortViewModel?.traffic.length )}`
                                : html` ${this._renderHeader('port', PortViewModel?.traffic.length )}`
                            }
                        </div>
                    </header>
                    ${this.portCityId ?
                        html`
                            <nav>
                                <div class="menu-item">
                                    <voy-dot-menu .dotMenuTitle=${'Port Memo'} .section=${"portmemo"}>
                                        ${PortViewModel?.terminals ?
                                            html`
                                                <p class="port-memo-title">Port Memos</p>
                                                ${PortViewModel?.terminals.map(terminal => {
                                                    return html` 
                                                        <button @click=${this._launchPortMemo(terminal.locationId)} class="port-memo-btn">${SvgIcons.customFile}<span class="memo-title">${terminal.locationId}</span></button>
                                                    `
                                                })}
                                            `
                                            : html``
                                        }
                                    </voy-dot-menu>
                                </div>
                            </nav>
                        `
                        :
                        html``
                    }
                </section>
                <div class="scrollhost">
                    ${this._renderTraffic()}
                </div>
            </div>
        `;
    }

    private _showVesselDetails(imo: number): void {
        UiStateModel!.setValue(UiStateModelParam.IMO, imo.toString());
        UiStateModel!.setValue(UiStateModelParam.PORT);
        UiStateModel!.setValue(UiStateModelParam.PortRegion);
        UiStateModel!.setValue(UiStateModelParam.FISubView, FiSubView.VesselDetails);
    }

    private _getTitle(): string {
        let title = '';
        if (this.ocl) {
            title = regionsMap.find(el => el.key === this.ocl)?.name || '';
        }

        if (this.portCityId) {
            if (this._selectedPort?.city) {
                title = this._selectedPort?.city + ' ' + this.portCityId;
            } else {
                title = this.portCityId;
            }
        }
        return title;
    }

    private _renderHeader(type: string, length?:number ):TemplateResult {
        return html`<div>
                ${
                    html`
                        <h1 class="show-terminals-container">
                            <span>${this._getTitle()}</span>
                            ${this._isDataFetching
                                ? this._loadingSpinner()
                                : type === 'port' ? html`${this._showTerminalsForCurrentPort()}` : html``
                            }
                        </h1>
                    `
                }
        </div>`
    }

    private _loadingSpinner() {
        return html`
            <div class="spinner-container">
                <div class="loading-spinner">
                    <voyage-spinner .transparent=${true}></voyage-spinner>
                </div>
            </div>
        `
    }


    private _renderPositionInfo(vessel: ListEntry):TemplateResult {
        //variable with default color 
        let className = "green-bg"

        const timeDiff = vessel.ais?.timestamp ? differenceInHours(new Date(), new Date(vessel.ais?.timestamp)) : null;
        
        if(timeDiff === null) {
            className = "gray-bg"
        } else if (timeDiff >= 4) {
            className = "red-bg"
        } else {
            className = "green-bg"
        }
        return html`

        <p class="position-info">${vessel.ais ?
            html`
                
            <div>   
                     <span class=${className}>${prettyTimelapsed(vessel.ais?.timestamp)} </span>
                
                <voyage-tooltip-proxy
                    text=${`Last position: ${prettyTimelapsed(vessel.ais?.timestamp)} ago <br> Source: ${getFormattedDataSource(vessel.ais?.source)}`}
                    html-content
                    .positionPriority=${["bottom"]}
                    .tooltipInteraction=${false}

                    >
                    </voyage-tooltip-proxy> 
        </div>
            `
            : html`<span class="gray-bg">No position</span>`}
        </p>
        
        `
    }

    private _renderTraffic(): TemplateResult[] {
        if (!PortViewModel) {
            return [];
        }


        return PortViewModel?.traffic.map((vessel) => {
            const dataSource = vessel.ais?.source;
            const formattedDataSource = dataSource ? getFormattedDataSource(dataSource!) : "--";
           
            return html`
                <div class="item">
                    <div>
                        <div class="vessel-name-container">
                            <h2 @click=${() => this._showVesselDetails(vessel.imo)}>${vessel.name || vessel.ais?.vesselName || vessel.imo}</h2>
                            <span class="maersk-icon">${vessel.isMaerskVessel ? SvgIcons.customMaerskIcon : html``}</span>
                        </div>
                        <div class="vessel-type">${vessel.vesselType}</div>
                    </div>
                    ${this._renderPositionInfo(vessel)}
                    ${
                        vessel.gsis
                        ? this._showGsisEntry(vessel)
                        : this._showAisEntry(vessel)
                    }
                </div>
            `;
        });
    }

    private _showGsisEntry(vessel: ListEntry) {
        const nextGsisEntry = vessel.gsis![0];
        const terminal = VoyageShoreContextModel!.terminalsMap.get(nextGsisEntry.arrival.arrivalTerminalCode)
        
        return html`
            <div class="arrival">
                <h3>Arr. GSIS (${nextGsisEntry.arrival.arrivalPortCall?.GSIS?.actuals.arrivalAt ? 'actual' : 'scheduled'})</h3>
                
                <p class="terminal">
                    ${terminal?.city + " " + nextGsisEntry.arrival.arrivalTerminalCode}
                </p>
                <p>
                    
                    ${this._formatDatetoLT(nextGsisEntry.arrival.arrivalPortCall?.GSIS?.actuals.arrivalAt || nextGsisEntry.arrival.arrivalPortCall?.GSIS?.arrivalAt || nextGsisEntry.arrival.arrivalAt, nextGsisEntry.arrival.arrivalTerminalCode)}
                </p>
                
            </div>
            ${vessel.isMaerskVessel
                ? html`
                    <div class="departure">
                        <h3>Dep. GSIS (${nextGsisEntry.departure?.departurePortCall?.GSIS?.actuals.departureAt ? 'actual' : 'scheduled'})</h3>
                        ${!nextGsisEntry.departure 
                            ? html``
                            : html`
                                <p class="terminal">${nextGsisEntry.departure.arrivalTerminalCode}</p>
                                <p>${this._formatDatetoLT(nextGsisEntry.departure.departurePortCall?.GSIS?.actuals.departureAt || nextGsisEntry.departure.departurePortCall?.GSIS?.departureAt || nextGsisEntry.departure.departureAt, nextGsisEntry.arrival.arrivalTerminalCode)}</p>
                            `
                        }
                    </div>
                `
                : html``
            }
        `
    }

    private _showAisEntry(vessel: ListEntry) {
        const aisEta = (new Date(vessel.ais?.etaScheduled || '')).getTime();
        const unloCode = vessel.ais?.currUnlocode;

         return html`
            <div class="arrival">
                <h3>Arr. AIS (estimated)</h3>
                <p class="terminal">${this._getCityName(this._convertUnlocodeToCityId(unloCode)) + " " + this._convertUnlocodeToCityId(unloCode)}</p>
                <p>${this._formatDatetoLT(aisEta, this._convertUnlocodeToCityId(unloCode))}</p>
            </div>
            ${vessel.ais?.mds
                ? html`
                    <div class="departure">
                        <h3>Dep. AIS (estimated)</h3>
                        <p class="terminal">
                            ${vessel.ais?.nextUnlocode ? html`${vessel.ais?.nextUnlocode}` : html``}
                        </p>
                        <p>${this._formatDatetoLT(vessel.ais.etaCalc, this._convertUnlocodeToCityId(vessel.ais?.nextUnlocode))}</p>
                    </div>
                `
                : html``
            }
        `
    }


    private _convertUnlocodeToCityId(id: string | undefined): string {
        return (id && PortViewModel?.unLocode2Rkst.get(id)) ?? 'Unknown';
    }

    private _getCityName(cityId: string): string {
        const terminals = TerminalsModel!.getTerminalsByCity(cityId);
        return terminals?.[0].city || 'Unknown';
    }


    private _formatDatetoLT(date: string | number, port: string) {
        let zone;

        if(port.length < 6) {
            const arrWithTerminals = TerminalsModel?.getTerminalsByCity(port);
            zone = arrWithTerminals && arrWithTerminals.length > 0 && arrWithTerminals.find(el => el.olsonTimezone !== undefined)?.olsonTimezone;
        
        } else {
           zone = TerminalsModel?.getTerminal(port)?.olsonTimezone;
        }
      
        const formatedDate = zone && FormatDateToLocalTime(date, zone);

        return formatedDate;
    }

    private _modelUpdated() {
        this.requestUpdate()
    }

    private _convertAISPortId(id: string | undefined): string {
        return id ? PortViewModel?.unLocode2Rkst.get(id) || id : 'Unknown';
    }

    private _filterOnSelctedTermial(checked: boolean, locationId: string) {
        if (!this._selectedTerminals ) {
            this._selectedTerminals = {
                cmd: 'tml',
                vals: []
            }
        }

        const selectedTerminal = this._selectedTerminals?.vals?.find(el => el === locationId.toLowerCase());
        if (selectedTerminal) {
            if (!checked) {
                this._selectedTerminals.vals = this._selectedTerminals.vals?.filter(el => el !== locationId.toLowerCase())
            }
        } else {
            if (checked) {
                this._selectedTerminals.vals?.push(locationId.toLowerCase())
            }
        }

        const convertedFiltersToString = FilterUtils.filterToString({ commands: [this._selectedTerminals] });
        UiStateModel!.setValue('q', convertedFiltersToString);
    }

    private _showTerminalsForCurrentPort(): TemplateResult {
        return html`
            <div class="terminal-container">
                <voy-dot-menu .dotMenuTitle=${SvgIcons.customFilterSliders} .section=${"terminal"} .right=${25} .controlableClose=${true} .showMenu=${this._showFilterPopup} @show-menu-updated=${(e: CustomEvent) => this._showFilterPopup = e.detail.state}>
                    ${PortViewModel?.terminals ?
                        html`
                            <div class="terminals-popup-title"><span>Terminals</span><button @click=${() => this._showFilterPopup = false}>${SvgIcons.lightTimes}</button></div>
                            <div class="checkboxes-wrapper">
                                ${PortViewModel?.terminals.map(terminal => {
                                    const checked = this._selectedTerminals?.vals?.find(el => el === terminal.locationId.toLowerCase());
                                    return html` 
                                        <voyage-checkbox .label=${terminal.locationId} data-test=${terminal.cityId} .checked=${checked} @input=${(e: Event) => this._filterOnSelctedTermial((<VoyageCheckbox>e.target).checked, terminal.locationId)}></voyage-checkbox>
                                    `
                                })}
                            </div>
                        `
                    : html``
                    }
                </voy-dot-menu>
            </div>
        `
    }

    private _toggleTimeLine():void {
        this._timeLineVisible = !this._timeLineVisible
    }
}
